import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AppSetting } from '../../../constants/appsetting.constant';

@Component({
  selector: 'app-footer',
  imports: [TranslateModule],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  currentYear: number = new Date().getFullYear();
  appSetting = AppSetting;
  goToLink(url: string) {
    window.open(url, '_blank');
  }
}
